<!-- Login Page-->
<section>
    <div class="container content-box">

        <!-- Form -->
        <form name="form" class="" (submit)="onSubmit(f.form)" #f="ngForm" novalidate>
            <h1 class="mb-4 text-center">Log in</h1>

            <!-- Input Fields -->
            <div class="col-md-12">

                <!-- Input Row -->
                <div class="row mt-2">

                    <!-- Email -->
                    <div class="col-md-12">
                        <input type="email" id="email" class="form-control mb-2 input-field" placeholder="E-mail" [(ngModel)]="user.email" name="email" #email="ngModel" [ngClass]="{ 'is-invalid': submitted && email.invalid }" required>

                        <!-- Invalid Email-->
                        <div *ngIf="submitted && email.invalid" class="invalid-feedback">
                            <div class="mb-1 text-center" *ngIf="email.errors!.required">Email is required</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-3">

                    <!-- Password -->
                    <div class="col-md-12">
                        <input type="password" id="password" class="form-control mb-2 input-field" placeholder="Password" [(ngModel)]="user.password" #password="ngModel" name="password" [ngClass]="{ 'is-invalid': submitted && password.invalid }" required>

                        <!-- Invalid Password -->
                        <div *ngIf="submitted && password.invalid" class="invalid-feedback">
                            <div class="mb-2 text-center" *ngIf="password.errors!.required">Password is required</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-3" *ngIf="recaptchaEnabled">

                  <!-- ReCAPTCHA -->
                  <div class="col-md-12 mb-4 input-field text-center">
                    <re-captcha #captcha="ngModel" [(ngModel)]="user.captcha" id="captcha" name="captcha" class="captcha" [ngClass]="{ 'is-invalid': submitted && captcha.invalid }" required></re-captcha>

                    <!-- Invalid -->
                    <div *ngIf="submitted && captcha.invalid" class="invalid-feedback">
                        <div class="mb-2" *ngIf="captcha.errors!.required">Captcha is required</div>
                    </div>
                  </div>
                </div>
            </div>

            <!-- Forgot Password -->
            <div class="text-center">
                <div class="d-flex justify-content-around">
                    <a [routerLink]="'/forgot-password'">Forgot password?</a>
                </div>

                <!-- Log in Button -->
                <button type="submit" id="login-button" class="my-4 btn" type="submit" [class.disabled]="submitting">Log in</button>

                <!-- Register -->
                <p>Don't have an account?
                    <a [routerLink]="'/sign-up'">Register</a>
                </p>

                <!-- Admin Login -->
                <small>
                    <a [routerLink]="'/admin/login'">Administrator Login</a>
                </small>
            </div>
